var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"150px"},attrs:{"id":_vm.id}}),_c('div',{staticClass:"center text"},[_vm._v("项目进度")])])
}
var staticRenderFns = []

export { render, staticRenderFns }